import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'recompose';
import { get } from 'lodash';

import { withShowHide } from 'decorators';
import { withOnVisibleFacilityHandler } from 'decorators/facility';
import { ClickToShowCallButton } from 'components/contact/ClickToShowCallButton';
import { Button } from 'components/core/Button';
import { Card } from 'components/core/Card';
import { Group } from 'components/core/Page';
import { H2, Paragraph } from 'components/core/Typography';
import { Link } from 'components/core/Link';
import { PhoneNumber } from 'components/contact/PhoneNumber';
import { FacilityImageNotAvailable } from 'components/facility/ImageNotAvailable';
import { Phone } from 'components/svg';
import { ViewportAction } from 'components/core/ViewportAction';

import './oonFacilityCard.scss';

export const enhance = compose(
	withOnVisibleFacilityHandler,
	withShowHide('phoneNumber')
);

export function OONFacilityCard({
	className, facility, onShowPhoneNumber, phoneNumberShowing,
	phone, onVisible, percentVisible
}) {
	return (
		<ViewportAction
			onVisible={onVisible}
			percentVisible={percentVisible}
		>
			<Card
				className={classNames('oon-facility-card', className)}
				itemScope
				itemType="https://schema.org/SelfStorage"
			>
				<Link
					className="oon-facility-image"
					href={facility.url.facility}
					hideBorder
				>
					<FacilityImageNotAvailable
						className="desktop"
						size="small"
						color="white"
						isOON
					/>
				</Link>
				<div className="oon-facility-details">
					<Group>
						<H2
							size="medium"
							className="facility-title"
						>
							<Link
								href={facility.url.facility}
								hideBorder
							>
								<span itemProp="name">
									{facility.name}
								</span>
							</Link>
						</H2>
					</Group>
					<Group>
						<Paragraph className="facility-subtitle">
							{facility.location.text}
						</Paragraph>
						{facility.phone && !phoneNumberShowing &&
							<Button
								link
								primary={false}
								onClick={onShowPhoneNumber}
								className="reveal-button questions"
							>
								Have billing or other questions for this facility?
							</Button>
						}
						{!!facility.phone && phoneNumberShowing &&
							<PhoneNumber
								phoneNumber={facility.phone}
								unformattedPhoneNumber={facility.phone.replace(/\D/g, '')}
								className="reveal-button"
								size="standard"
								clickable
							/>
						}
					</Group>
				</div>
				<Group>
					<Paragraph>
						We're unable to provide reservations for this facility.
					</Paragraph>
				</Group>
				<div className="buton-container">
					<ClickToShowCallButton
						initialLabel={(
							<span className="phone-number">
								<Phone />Call SpareFoot
							</span>
						)}
						asButton
						outline
						phoneNumber={get(phone, 'nationalSparephone')}
						unformattedPhoneNumber={get(phone, 'nationalSparephoneUnformatted')}
					/>
					<Button
						href={facility.url.facility}
					>
						More info<span className="hidden-text">  about {facility.name}</span>
					</Button>
				</div>
			</Card>
		</ViewportAction>
	);
}

OONFacilityCard.propTypes = {
	facility: PropTypes.object.isRequired,
	onShowPhoneNumber: PropTypes.func,
	phoneNumberShowing: PropTypes.bool,
	className: PropTypes.string,
	onVisible: PropTypes.func,
	phone: PropTypes.shape({
		nationalSparephone: PropTypes.string.isRequired,
		nationalSparephoneUnformatted: PropTypes.string.isRequired
	}),
	percentVisible: PropTypes.number
};

export default enhance(OONFacilityCard);
